module.exports = __webpack_public_path__ + "img/bus-area-01.8edd1667.png";